import { MapPosition } from '../types/mapposition';
import { SLMap } from './sl-map';
import { ViewContext } from '../types/view-context';
import { InterruptableTimer } from './interruptabletimer';
import { EventEmitter } from '@angular/core';
import { NavEvent } from './NavEvents';
import { NavigationAction } from './map-actions/navigation-action';
import { emit } from 'cluster';
import { ISLMap } from '../types/@types/sl-map';



export class NavHistory {
  private cursorIndex = -1;
  private history: Array<ViewContext> = [];
  private map: ISLMap;
  private timer: InterruptableTimer = new InterruptableTimer(1000);
  private enabled = true;
  public changes: EventEmitter<any> = new EventEmitter();
  public wasIdle = true;
  private isUserInteracting: boolean = false;
  constructor(map: ISLMap) {
    this.map = map;
  }

  Init() {
    if (!this.map.ui) {
      throw new Error('premature initilization of nav history');
    }
    this.history = [];
    this.Append(this.map.currentViewState);
    /*this.map.ui.on('mousemove', (event: any | NavEvent) => {
      if ((event as MouseEvent).buttons) {
        if (event.buttons.length > 0) {

          this.StopTimer();

        }
      }
      if ((event as TouchEvent).touches) {
        if (event.touches.length > 0) {
          this.StopTimer();
        }
      }

    });

    this.map.ui.on('moveend', (event: any | NavEvent) => {
      if (event.historical || event.internal) {
        // ignore
        return;
      } else {
        this.StopTimer();
        this.UpdateTimer();
      }
    });
    */
    this.map.ui.on('moveend', (event: any) => {
      if ((event.internal === true) || event.historical === true) {
        return;
      }
      this.wasIdle = false;
    });
    this.map.ui.on('idle', (event: any) => {
      if (this.wasIdle === false && !this.isUserInteracting) {
        this.Update();
        this.wasIdle = true;
      }
    });
    this.map.ui.getCanvas().addEventListener('mousedown', () => {
      this.isUserInteracting = true;
    });
    this.map.ui.getCanvas().addEventListener('mouseup', () => {
      this.isUserInteracting = false;
    });
    this.map.ui.getCanvas().addEventListener('touchstart', () => {
      this.isUserInteracting = true;
    });
    this.map.ui.getCanvas().addEventListener('touchend', () => {
      this.isUserInteracting = false;
    });


  }
  Enable() {
    this.enabled = true;
  }
  Disable() {
    this.timer.Stop(false);
    this.enabled = false;
  }
  Update() {
    if (this.enabled === false) return;
    if(this.isUserInteracting === true) return;
    this.Append(this.map.currentViewState);
    NavigationAction.UpdateHistoryButtons(this.map.component);
    this.changes.emit({ type: 'nav-history-change', history: this });
  }
  UpdateTimer() {
    if (this.enabled === false) return;
    if (this.timer.isSampling === true) {
      this.timer.Interrupt(true);
      return;
    }
    this.timer.Start(() => {
      this.Update();
      this.StopTimer();
    });
  }
  StopTimer() {
    if (this.enabled === false) { return; }
    if (this.timer.isSampling === true) {
      this.timer.Stop();
      return;
    }
  }

  Compare(positionA: ViewContext, positionB: ViewContext): boolean {
    if (!positionA) { return false; }
    if (!positionB) { return false; }
    if (positionA.position.location.center.lat.toString().substr(0, 11) !== positionB.position.location.center.lat.toString().substr(0, 11)) {
      return false;
    }
    if (positionA.position.location.center.lng.toString().substr(0, 11) !== positionB.position.location.center.lng.toString().substr(0, 11)) {
      return false;
    }
    let trueCount = 0;
    trueCount += (positionA.position.location.bearing === positionB.position.location.bearing) ? 1 : 0;
    trueCount += (positionA.position.location.pitch === positionB.position.location.pitch) ? 1 : 0;
    trueCount += (positionA.position.location.zoom === positionB.position.location.zoom) ? 1 : 0;
    return (trueCount === 3);



  }

  Append(position: ViewContext) {
    if (this.cursorIndex > -1) {
      const historical: ViewContext = this.history[this.cursorIndex];
      if (this.Compare(historical as ViewContext, position) === true) {
        return;
      }
    }
    if (this.cursorIndex === this.history.length - 1) {
      this.history.push(position);
      this.cursorIndex = this.history.length - 1;
    } else {
      this.history.splice(this.cursorIndex + 1, this.history.length - this.cursorIndex);
      this.cursorIndex = this.history.length - 1;
      this.Append(position);
    }
    NavigationAction.UpdateHistoryButtons(this.map.component);

  }
  HasNext() {
    return !(this.cursorIndex === this.history.length - 1);
  }
  Next(event: NavEvent): boolean | ViewContext {
    if (!this.HasNext()) {
      return false;
    }
    return this.GoTo(this.cursorIndex + 1, event);

  }
  HasPrev() {
    return this.cursorIndex > 0;
  }
  Prev(event: NavEvent): boolean | ViewContext {
    if (!this.HasPrev()) {
      return false;
    }
    return this.GoTo(this.cursorIndex - 1, event);

  }
  GetCurrent(): boolean | ViewContext {
    if (this.cursorIndex < 0) {
      return false;
    }
    if (this.cursorIndex >= this.history.length) {
      return false;
    }

    return this.history[this.cursorIndex];
  }
  GoToFirst(event: NavEvent): boolean | ViewContext {
    this.cursorIndex = 0;
    return this.GoTo(0, event);

  }
  GoToLast(event: NavEvent): boolean | ViewContext {
    return this.GoTo(this.history.length - 1, event);

  }
  private GoTo(index: number, event: NavEvent): boolean | ViewContext {
    this.cursorIndex = index;
    const context = this.GetCurrent();
    if (context === false || context === true) { return false; }
    this.map.SetViewState(context, event);
    NavigationAction.UpdateHistoryButtons(this.map.component);
    this.changes.emit({ action: 'change', navEvent: event });
    return context;
  }

}
